import React, { useEffect, useState } from "react";
import { Dropdown } from "antd";

const Tags = ({ post, searchByTag, isMobile }) => {
  const len = isMobile ? 1 : 2;

  const [items, setItems] = useState([]);

  useEffect(() => {
    const arr = post?.tags?.slice(len).map((tag) => ({
      key: tag.id,
      label: (
        <p
          style={{ fontWeight: 600, color: "#2a71d4" }}
          onClick={(e) => {
            e.stopPropagation();
            searchByTag(e, tag.name.toLowerCase());
          }}
        >
          #{tag.name}
        </p>
      ),
    }));
    setItems(arr);
  }, [isMobile, post]);

  const onClick = (e) => e?.stopPropagation();

  return (
    <>
      {post?.tags.length <= len ? (
        <div className="tags">
          {post?.tags?.map((tag) => (
            <div
              key={tag.id}
              className="custom-tag"
              onClick={(e) => searchByTag(e, tag.name.toLowerCase())}
            >
              #{tag.name}
            </div>
          ))}
        </div>
      ) : (
        <div className="tags">
          {post?.tags?.slice(0, len).map((tag) => (
            <div
              key={tag.id}
              className="custom-tag"
              onClick={(e) => searchByTag(e, tag.name.toLowerCase())}
            >
              #{tag.name}
            </div>
          ))}

          <Dropdown menu={{ items, onClick }} trigger={["hover", "click"]}>
            <div className="custom-tag" onClick={(e) => e.stopPropagation()}>
              +{post?.tags.length - len}
            </div>
          </Dropdown>
        </div>
      )}
    </>
  );
};

export default Tags;
